import React from 'react'
import { render } from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import { Provider } from 'react-redux';

import App from './App'
import './index.css'
import './assets/fonts/font-awesome.min.css'
import "react-toastify/dist/ReactToastify.css"
import { store } from './ReduxStore/index';

// render(<App/>, document.getElementById('root'));
//render(<BrowserRouter><App/></BrowserRouter>,document.getElementById('root'))

render(
    <BrowserRouter basename="/">
        <Provider store={store}>
            <App/>
        </Provider>
    </BrowserRouter>
    ,document.getElementById('root')
);